import { combineReducers } from 'redux'
import config from './config'

export default combineReducers({
  config,
})
